import React from "react";
import axios from "axios";
import { CheckCircle2 } from "lucide-react";
import { useContent } from "@/lib/contentStore";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function ContactDialog({ open, onOpenChange, source = "contact_dialog" }) {
  const { content } = useContent();
  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [msg, setMsg] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [submitError, setSubmitError] = React.useState("");

  const resetForm = () => {
    setName("");
    setPhone("");
    setEmail("");
    setMsg("");
    setSubmitError("");
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitError("");
    setIsSubmitting(true);
    try {
      await axios.post("/api/leads", {
        name,
        phone,
        email,
        message: msg || email || "",
        source,
      });
      onOpenChange(false);
      resetForm();
      window.alert("Спасибо! Заявка отправлена. Мы свяжемся с вами в ближайшее время.");
    } catch {
      setSubmitError("Не удалось отправить заявку. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1rem)] max-h-[88vh] overflow-y-auto rounded-2xl border-[#d7cfbf] bg-white p-4 shadow-[0_24px_50px_rgba(31,26,23,0.25)] sm:max-w-[560px] sm:p-6">
        <DialogHeader>
          <DialogTitle>Получите персональное предложение от DALINI</DialogTitle>
        </DialogHeader>

        <div className="text-sm leading-6 text-zinc-700">
          Оставьте контакты и мы подберем решение под ваш интерьер, материалы и бюджет.
        </div>

        <div className="grid grid-cols-1 gap-2 rounded-lg border border-[#ebe5db] bg-[#faf8f4] p-3 text-sm text-[#3d372f]">
          <div className="inline-flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-[#1f6a54]" />
            Расчет стоимости и сроков
          </div>
          <div className="inline-flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-[#1f6a54]" />
            Помощь с подбором материалов и отделки
          </div>
          <div className="inline-flex items-center gap-2">
            <CheckCircle2 className="h-4 w-4 text-[#1f6a54]" />
            Консультация менеджера без обязательств
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <Input
            placeholder="Ваше имя *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <Input
            placeholder="Телефон *"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
          <Input
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />
          <Input
            placeholder="Что вас интересует?"
            value={msg}
            onChange={(e) => setMsg(e.target.value)}
          />

          {submitError ? <div className="text-sm text-red-600">{submitError}</div> : null}
          <div className="flex flex-col items-stretch justify-between gap-3 pt-1 sm:flex-row sm:items-center">
            <div className="text-xs text-zinc-500">* — обязательные поля</div>
            <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto">
              {isSubmitting ? "Отправка..." : "Получить консультацию"}
            </Button>
          </div>

          <div className="break-words pt-1 text-xs text-zinc-500">
            Контакты: {content.contacts.phone}, {content.contacts.address}
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
